import React, { useEffect, useRef, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { addSentencesData } from "../../database/addSentencesData";
const Honeycomb = (props) => {
  const [honeyCellState, setHoneyCellState] = useState("");
  const [flag, setFlag] = useState(false);
  let honeycomb_scale;
  let margin_top;
  let margin_left;
  let height;
  let width;
  if (window.innerWidth < 700) {
    honeycomb_scale = 0.5;
    margin_left = "auto";
    margin_top = "0px";
    height = "50vh";
    width = "60vw";
  } else {
    width = "50vw";
    height = "60vh";
    margin_left = "350px";
    margin_top = "70px";
  }

  //style
  const honeycombStructure = css`
    transform: translateY(-80px);
    position: relative;
    z-index: 1;
    transform: scale(${honeycomb_scale});
    height: ${height};
    width: ${width};
    margin-top: ${margin_top};
    margin-left: ${margin_left};

    .honeycombArea {
      transform: scale(${honeycomb_scale});
      width: 1px;
      height: 1px;
      user-select: none;
      position: relative;
    }

    .hxagon-top-label {
      color: #0026ff;
      font-size: 0.8em;

      position: absolute;
      white-space: nowrap;
      font-weight: bold;
      background-color: white;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;
    }

    .hxagon-top-label-2 {
      color: #02b738;
      font-size: 0.8em;

      position: absolute;
      white-space: nowrap;
      font-weight: bold;
      background-color: white;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;
    }

    .hxagon-top-label-3 {
      color: #000000;
      font-size: 0.8em;

      position: absolute;
      white-space: nowrap;
      font-weight: bold;
      background-color: white;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;
    }

    .hxagon-top-content-blue {
      width: calc(196px - 50px);
      top: 26%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      font-size: 25px;
      color: #0026ff;
      z-index: 11;
    }

    .hxagon-bottom-content-blue {
      width: calc(196px - 50px);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      font-size: 25px;
      bottom: 26%;
      color: #0026ff;
      z-index: 11;
    }

    .hxagon-top-content-green {
      position: absolute;
      top: 26%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(196px - 50px);
      position: absolute;
      font-size: 25px;
      color: #02b738;
      z-index: 11;
    }

    .hxagon-bottom-content-green {
      width: calc(196px - 50px);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      font-size: 25px;
      bottom: 26%;
      color: #02b738;
      z-index: 11;
    }

    .hxagon-top-content-deep-red {
      position: absolute;
      width: calc(196px - 50px);
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 25px;
      top: 26%;
      color: #b12c52;
      z-index: 11;
    }

    .hxagon-bottom-content-red {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      width: calc(196px - 50px);
      font-size: 25px;
      bottom: 26%;
      color: red;
      z-index: 11;
    }

    .hxagon-bottom-content-black {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      width: calc(196px - 50px);
      font-size: 25px;
      bottom: 26%;
      color: #000000;
      z-index: 11;
    }

    .hxagon-top-content-black {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(196px - 50px);
      font-size: 25px;
      top: 26%;
      color: #000000;
      z-index: 11;
    }



    .hxagon-follow-word-top {
      color: #0026ff;
      font-size: 0.8em;
      font-weight: bold;
      position: absolute;
      top: 32%;
      right: -27%;
      z-index: 11;
    }

    .hxagon-follow-word-bottom {
      color: #0026ff;
      font-size: 0.8em;

      font-weight: bold;
      line-height: 1.0em;
      position: absolute;
      bottom: 25%;
      right: -27%;
      z-index: 11;
    }

    .hxagon1-wrap {
      width: 196px;
      height: 228px;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon2-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px / 4 - 2.26px);
      left: calc(196px / 2 - 0.4px);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon3-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px / 4 - 2.26px);
      left: calc(-1 * (196px / 2 - 0.52px));
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon4-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px - (2.26px * 2));
      left: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon5-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px - (2.26px * 2));
      left: calc(-1 * (196px - (0.52px * 2)));
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon6-wrap {
      width: 196px;
      height: 228px;
      top: calc(228px / 2 + 228px / 4 - 2.26px);
      left: calc(-1 * (196px / 2 - 0.52px) * 3);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hxagon7-wrap {
      width: 196px;
      height: 228px;
      top: 0px;
      left: calc(-1 * (196px - (0.52px * 2)));
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
    }

    .hexagon1Area {
      text-align: center;
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .hexagon2Area {
      text-align: center;
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }



    .hexagon-1,
    .hexagon-2,
    .hexagon-3,
    .hexagon-4,
    .hexagon-5,
    .hexagon-6,
    .hexagon-7 {
      transform: rotate(90deg);
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      position: relative;
    }

    .middle-line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      height: calc(130px * 1.5 - 3px);
      width: 0.001px;
      outline: 0.5px solid rgb(79, 79, 79);
      outline-style: dashed;
      z-index: 1;
    }

    .hexagon-1 div,
    .hexagon-2 div,
    .hexagon-3 div,
    .hexagon-4 div,
    .hexagon-5 div,
    .hexagon-6 div,
    .hexagon-7 div {
      width: calc(75px * 1.5);
      /* 辺の長さを調整 */
      height: calc(130px * 1.5);
      /* 辺の長さを調整 */
      position: absolute;
      /* 辺の長さを調整 */
      transform-origin: center;
      /* 初期値だけど必要な時用 */
      box-sizing: border-box;
    }

    .hexagon-1 div,
    .hexagon-7 div {
      /* 位置を調整 */
      border-top: 2px solid #0026ff;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #0026ff;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-2 div {
      /* 位置を調整 */
      border-top: 2px solid #02b738;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #02b738;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-3 div {
      /* 位置を調整 */
      border-top: 2px solid #ff0707;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #ff0707;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-4 div,
    .hexagon-5 div,
    .hexagon-6 div {
      /* 位置を調整 */
      border-top: 2px solid #000000;
      /* 辺の長さを調整 */
      border-bottom: 2px solid #000000;
      /* 調節しやすくなる */
      background-color: rgb(255, 255, 255);
    }

    .hexagon-1 div:nth-of-type(1),
    .hexagon-2 div:nth-of-type(1),
    .hexagon-3 div:nth-of-type(1),
    .hexagon-4 div:nth-of-type(1),
    .hexagon-5 div:nth-of-type(1),
    .hexagon-6 div:nth-of-type(1),
    .hexagon-7 div:nth-of-type(1) {
      transform: rotate(0deg);
    }

    .hexagon-1 div:nth-of-type(2),
    .hexagon-2 div:nth-of-type(2),
    .hexagon-3 div:nth-of-type(2),
    .hexagon-4 div:nth-of-type(2),
    .hexagon-5 div:nth-of-type(2),
    .hexagon-6 div:nth-of-type(2),
    .hexagon-7 div:nth-of-type(2) {
      transform: rotate(60deg);
    }

    .hexagon-1 div:nth-of-type(3),
    .hexagon-2 div:nth-of-type(3),
    .hexagon-3 div:nth-of-type(3),
    .hexagon-4 div:nth-of-type(3),
    .hexagon-5 div:nth-of-type(3),
    .hexagon-6 div:nth-of-type(3),
    .hexagon-7 div:nth-of-type(3) {
      transform: rotate(120deg);
    }

  `;
  return (
    < >
      < div className="honeycombArea-wrap" css={honeycombStructure} >
        <div className='honeycombArea'>
          <div className='hxagon1-wrap'>
            <div className='hexagon1Area'>
              <div className="hxagon-top-content-blue" id="whatTop">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whatTop
                }
              </div>
              <div className="hxagon-bottom-content-blue" id="whatBottom">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whatBottom
                }
              </div>
              <div className="hxagon-top-label">what なに</div>
              <div className="hxagon-follow-word-top">は</div>
              <div className="hxagon-follow-word-bottom">に<br />を<br />〜</div>
              <div className="hexagon-1">
                <span className='middle-line'></span>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div className='hxagon2-wrap'>
            <div className='hexagon2Area'>
              <div className="hxagon-top-content-green" id="howTop">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.howTop
                }
              </div>

              {/* <div className="hxagon-bottom-content-green" id="howBottom">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.howBottom
                }
              </div> */}

              <div className="hxagon-top-label-2">how どんな</div>
              <div className="hexagon-2">
                <div></div>
                <div></div>
                <div></div>
              </div>

            </div>
          </div>
          <div className='hxagon3-wrap'>
            <div className='hexagon2Area'>
              <div className="hxagon-top-content-deep-red" id="doTop">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.doTop
                }
              </div>
              <div className="hxagon-bottom-content-red" id="doBottom">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.doBottom
                }
              </div>
              <div className="hexagon-3">
                <span className='middle-line'></span>
                <div></div>
                <div></div>
                <div></div>
              </div>

            </div>
          </div>
          <div className='hxagon4-wrap'>
            <div className='hexagon2Area'>
              <div className="hxagon-top-content-black">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whereTop
                }
              </div>
              <div className="hxagon-bottom-content-black">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whereBottom
                }
              </div>
              <div className="hxagon-top-label-3">where どこ</div>
              <div className="hexagon-4">
                <div></div>
                <div></div>
                <div></div>
              </div>

            </div>
          </div>
          <div className='hxagon5-wrap'>
            <div className='hexagon2Area'>
              <div className="hxagon-top-content-black">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whenTop
                }
              </div>
              <div className="hxagon-bottom-content-black">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whenBottom
                }
              </div>
              <div className="hxagon-top-label-3">when いつ</div>
              <div className="hexagon-5">
                <div></div>
                <div></div>
                <div></div>
              </div>

            </div>
          </div>
          <div className='hxagon6-wrap'>
            <div className='hexagon2Area'>
              <div className="hxagon-top-content-black">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whyTop
                }
              </div>

              {/* <div className="hxagon-bottom-content-black">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whyBottom
                }
              </div> */}

              <div className="hxagon-top-label-3">why なぜ</div>
              <div className="hexagon-6">
                <div></div>
                <div></div>
                <div></div>
              </div>

            </div>
          </div>
          <div className='hxagon7-wrap'>
            <div className='hexagon2Area'>
              <div className="hxagon-top-content-blue">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whoTop
                }
              </div>
              <div className="hxagon-bottom-content-blue">
                {props.sentence_id === 0 ?
                  ""
                  :
                  props.whoBottom
                }
              </div>
              <div className="hxagon-top-label">who だれ</div>
              <div className="hxagon-follow-word-top">は</div>
              <div className="hxagon-follow-word-bottom">に<br />を<br />〜</div>
              <div className="hexagon-7">
                <span className='middle-line'></span>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div >

    </>
  );

};

export default Honeycomb;
